"use strict";

_BannerFlowApp.directive("checkbox", function () {
    return {
        scope: {},
        require: "ngModel",
        restrict: "E",
        replace: "true",
        template:
            "<button type=\"button\" class=\"bf-checkbox\" ng-class=\"{'xs': size==='default', 'sm': size==='large', 'lg': size==='largest', 'checked': checked===true}\">" +
            '<span ng-style="styleicon" ng-class="{\'fa fa-check\': checked===true}"></span>' +
            "</button>",
        link: function (scope, elem, attrs, modelCtrl) {
            scope.size = "default";
            // Default Button Styling
            scope.stylebtn = {};
            // Default Checkmark Styling
            scope.styleicon = { width: "10px", left: "-1px" };
            // If size is undefined, Checkbox has normal size (Bootstrap 'xs')
            if (attrs.large !== undefined) {
                scope.size = "large";
                scope.stylebtn = { "padding-top": "2px", "padding-bottom": "2px", height: "30px" };
                scope.styleicon = { width: "8px", left: "-5px", "font-size": "17px" };
            }
            if (attrs.larger !== undefined) {
                scope.size = "larger";
                scope.stylebtn = { "padding-top": "2px", "padding-bottom": "2px", height: "34px" };
                scope.styleicon = { width: "8px", left: "-8px", "font-size": "22px" };
            }
            if (attrs.largest !== undefined) {
                scope.size = "largest";
                scope.stylebtn = { "padding-top": "2px", "padding-bottom": "2px", height: "45px" };
                scope.styleicon = { width: "11px", left: "-11px", "font-size": "30px" };
            }
            if (attrs.tiny !== undefined) {
                scope.size = "default";
                scope.stylebtn = {
                    "padding-top": "0px",
                    "padding-bottom": "2px",
                    height: "14px",
                    width: "14px",
                    "line-height": "0px"
                };
                scope.styleicon = { width: "8px", left: "-3px", "font-size": "10px" };
            }

            var trueValue = true;
            var falseValue = false;

            if (attrs.reversed) {
                trueValue = false;
                falseValue = true;
            }

            // If defined set true value
            if (attrs.ngTrueValue !== undefined) {
                trueValue = attrs.ngTrueValue;
            }
            // If defined set false value
            if (attrs.ngFalseValue !== undefined) {
                falseValue = attrs.ngFalseValue;
            }

            // Check if name attribute is set and if so add it to the DOM element
            if (scope.name !== undefined) {
                elem.name = scope.name;
            }

            // Update element when model changes
            scope.$watch(
                function () {
                    if (modelCtrl.$modelValue === trueValue) {
                        modelCtrl.$setViewValue(trueValue);
                    } else {
                        modelCtrl.$setViewValue(falseValue);
                    }
                    return modelCtrl.$modelValue;
                },
                function (newVal, oldVal) {
                    scope.checked = modelCtrl.$modelValue === trueValue;
                },
                true
            );

            // On click swap value and trigger onChange function
            if (!attrs.clickThrough) {
                elem.bind("click", function () {
                    scope.$apply(function () {
                        if (modelCtrl.$modelValue === falseValue) {
                            modelCtrl.$setViewValue(trueValue);
                        } else {
                            modelCtrl.$setViewValue(falseValue);
                        }
                    });
                });
            }
        }
    };
});
